import { useMemo } from 'react';
import type { ComponentPropsWithRef } from 'react';

import { parseDate } from '@internationalized/date';

import { tv } from '@simplywallst/ui-core/next';

import { DateInput } from '../DateInput';
import { styles } from './styles';

const textField = tv({
  extend: styles,
});

type Props = Omit<ComponentPropsWithRef<typeof DateInput>, 'value'> & {
  value?: Date | null;
  label?: string;
  error?: string | null;
  className?: string;
  isDisabled?: boolean;
};

export const DateField = ({
  value,
  label,
  error,
  isDisabled,
  className,
  ...props
}: Props) => {
  const parsedDate = useMemo(() => {
    const date = value ?? new Date();
    return value
      ? parseDate(
          new Date(date.getTime() - date.getTimezoneOffset() * 60000)
            .toISOString()
            .split('T')[0]
        )
      : undefined;
  }, [value]);

  const hasError = error !== undefined && error !== '' && error !== null;

  const styles = textField({
    isDisabled,
    hasError,
  });

  return (
    <fieldset
      data-invalid={hasError}
      className={styles.fieldset({ className })}
    >
      {typeof label !== 'undefined' && (
        <label className={styles.label()}>{label}</label>
      )}
      <div className={styles.input()}>
        <DateInput className={styles.inputEl()} value={parsedDate} {...props} />
      </div>
      {hasError && <span className={styles.error()}>{error}</span>}
    </fieldset>
  );
};
